import React, { useEffect, useState } from "react";
import { withRouter } from "react-router";
import classnames from "classnames";
import { connect } from "react-redux";
import { toast } from "react-toastify";
import * as actions from "../../../../store/actions";
import Row from "../../../../components/uiElements/grid/Row";
import Button from "../../../../components/formElements/button/Button";
import OnboardingIcon from "../../../../components/uiElements/icons/onboardingIcons/OnboardingIcon";
import constants, { getOnboardingPath } from "../../../../constants";
import {
  VALIDATE_PATIENT_DOSESPOT_PROFILE,
  REMOVE_VALIDATIONS,
} from "../../../../store/actions/actionTypes";

const DoseSpotPatient = ({
  createPatientDoseSpotProfile,
  patientPersonalInfo,
  getSSOURLPatient,
  history,
  removeValidations,
  form,
  validateData,
}) => {
  const [ssoUrl, setSSOUrl] = useState();

  let doseSpotPatientId = process.env.REACT_APP_DOSESPOT_PATIENT;

  useEffect(() => {
    getSSOURLPatient(
      doseSpotPatientId,
      patientPersonalInfo?.dosespot_id,
      data => {
        console.log("Debug SSO data: ", data);
        setSSOUrl(data?.url);
      }
    );

    form.dosespot = false;
    toast.error(form.dosespot_id, {
      position: constants.TOAST_POSITION,
    });
    //eslint-disable-next-line
  }, [form]);

  useEffect(() => {
    removeValidations();
    // eslint-disable-next-line
  }, []);

  return (
    <>
      <div
        className={classnames("pt-5 pl-3 pr-3")}
        style={{
          paddingBottom: 10,
        }}
      >
        <p className="onboarding-header m-0 pb-3">e-Prescription Profile</p>

        {patientPersonalInfo?.dosespot_id ? (
          <p
            style={{
              textAlign: "justify",
            }}
          >
            e-Prescription Profile has been created sucessfully.
          </p>
        ) : (
          <>
            <p
              style={{
                textAlign: "justify",
              }}
            >
              To create a profile on e-Prescription please click on below
              button.
            </p>
            ,
            <Row
              style={{
                paddingTop: "40vh",
              }}
            >
              <Button
                type="info"
                className={classnames("w-50 mx-auto my-5")}
                label={"Create e-Prescription Profile"}
                onClick={() => createPatientDoseSpotProfile()}
              />
            </Row>
          </>
        )}
      </div>
      {patientPersonalInfo?.dosespot_id ? (
        <Row>
          <Button
            type="secondary"
            indicatorButton
            className={classnames(
              "float-right next-button-dosespot1",
              patientPersonalInfo.dataLoaded && "enable"
            )}
            label={<OnboardingIcon type="nextButton" />}
            onClick={() =>
              patientPersonalInfo.dosespot_id
                ? history.push(getOnboardingPath("/step2"))
                : validateData(patientPersonalInfo)
            }
          />
        </Row>
      ) : (
        <Row>
          <Button
            type="secondary"
            indicatorButton
            className={classnames(
              "float-right next-button-dosespot",
              patientPersonalInfo.dataLoaded && "enable"
            )}
            label={<OnboardingIcon type="nextButton" />}
            onClick={() =>
              patientPersonalInfo.dosespot_id
                ? history.push(getOnboardingPath("/step2"))
                : validateData(patientPersonalInfo)
            }
          />
        </Row>
      )}
    </>
  );
};

const mapStoreToProps = ({ onboarding, auth, validation }) => ({
  patientPersonalInfo: onboarding.patientPersonalInfo,
  form: validation.data,
});

const mapDispatchToProps = dispatch => ({
  createPatientDoseSpotProfile: () =>
    dispatch(actions.createPatientDoseSpotProfile()),
  getSSOURLPatient: (userID, cb) =>
    dispatch(actions.getSSOURLPatient(userID, cb)),
  validateData: patientPersonalInfo =>
    dispatch(
      actions.validateData(
        VALIDATE_PATIENT_DOSESPOT_PROFILE,
        patientPersonalInfo
      )
    ),
  removeValidations: () =>
    dispatch(actions.validateData(REMOVE_VALIDATIONS, {})),
});

export default withRouter(
  connect(mapStoreToProps, mapDispatchToProps)(DoseSpotPatient)
);
